import React from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';

interface BreadcrumbProps {
  label: string;
  href?: string;
  isActive?: boolean;
  isLast?: boolean;
  isFirst?: boolean;
}

const Breadcrumb = ({ label, href, isActive, isLast, isFirst }: BreadcrumbProps): React.JSX.Element => {
  const baseStyles = classNames(
    'font-family font-normal first-letter:uppercase',
    {
      'px-1': !isFirst && !isLast,
      'pr-1': isFirst,
      'pl-1': isLast,
      'text-gray-500': isActive,
      'text-blue-700': !isActive,
    }
  );

  return (
    <>
      {isActive ? (
        <p className={baseStyles}>{label}</p>
      ) : (
        <Link to={href ?? ''} className={baseStyles}>
          {label}
        </Link>
      )}
      {!isLast && <span className="text-gray-500">/</span>}
    </>
  );
};

export default Breadcrumb;
